<template>
    <v-tooltip location="top">
        <template v-slot:activator="{props}">
            <v-icon end color="red" v-bind="props">mdi-bag-checked</v-icon>
        </template>
        <slot>
            <div class="text-white text-subtitle-2 px-0 pt-0">
                {{ $t('corporate_policy_not_match') }}
            </div>
            <div v-if="policies.length">
                {{ $t('violated_conditions') }}
                <div v-for="policy in policies" :key="policy.corporatePolicyId">
                    <span>
                        <span class="px-2">&#183;</span>
                        {{ policy.corporatePolicyName }}
                    </span>
                    <span>{{ policy.corporatePolicyDescription }}</span>
                </div>
            </div>
        </slot>
    </v-tooltip>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator'

    @Component
    export class CorporatePolicyViolation extends Vue {
        @Prop({default: () => []}) policies
    }

    export default CorporatePolicyViolation
</script>
